import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  doc_desc: fromDatatype.VarcharDatatypeInterface;
  doc_remarks: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  issue_date: fromDatatype.TimestampTzDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_to_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_from_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_budget_generic_doc_hdr_RowClass
  implements bl_fi_budget_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  doc_desc: fromDatatype.VarcharDatatypeInterface;
  doc_remarks: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  issue_date: fromDatatype.TimestampTzDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_to_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_from_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
}
